import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  deleteInvPackingDoc5M,
  deleteInvPackingDocAggregate,
  deleteInvPackingDocTractor,
  getContainerMasterDocs,
} from "../../services/ContainerMasterService";
import { toast } from "react-toastify";
import { viewDoc } from "../../services/dataService";
import LoaderSpinner from "./LoaderSpinner";
import { dispatcher } from "../../store/storeHelpers";
import * as actionTypes from "../../store/ActionTypes";
import store from "../../store/Store";
import { includes } from "lodash";
import { Typewriter } from "typewriting-react";

function InvoicePackagingPDFViewer({ show, hide, date, type }) {
  const [loader, setLoader] = useState(false);
  const [docInvoiceLink, setDocInvoiceLink] = useState([]);
  const [showIframe, setShowIframe] = useState("");
  const [isDelete, setIsDelete] = useState({
    status:false,
    ID:""
  })
  const [dataPresent, setDataPresent] = useState([])

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setDocInvoiceLink(Object.values(store.getState().invoice_packing_doc));
    });
    return () => {
      unsubscribe();
    };
  });

  useEffect(() => {
    setDocInvoiceLink("");
    setShowIframe("");
    async function getInvoiceDoc() {
      try {
        setLoader(true);
        var filteredResponse = [];
        var invoiceList = [];
        const response = await getContainerMasterDocs(show.row.original.ContainerMasterId);
        for (let i = 0; i < response.data.length; i++) {
            filteredResponse.push(response.data[i]);
        }
        for (let j = 0; j < filteredResponse.length; j++) {
          const invoiceResponse = await viewDoc(
            filteredResponse[j].InvoicePackingDoc?filteredResponse[j].InvoicePackingDoc:""
          );
          invoiceList.push({
            ...filteredResponse[j],
            docLink: invoiceResponse.data.Message,
          });
        }
        setDataPresent(invoiceList)
        dispatcher(actionTypes.LOAD_INVOICE_PACKING_DOC, invoiceList);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        toast.error(error.response.Message);
      }
    }
    getInvoiceDoc();
  }, [show, date]);

  async function deleteDoc(item) {
    setIsDelete({
      status: true,
      ID: item.ID,
    });
    try {
      if (item.DataOf === "TRACTOR") {
        await deleteInvPackingDocTractor(item.ID);
        dispatcher(actionTypes.DELETE_INVOICE_PACKING_DOC, item.ID);
        toast.success("Document deleted successfully");
      }
      if (item.DataOf === "AGGREGATE") {
        await deleteInvPackingDocAggregate(item.ID);
        dispatcher(actionTypes.DELETE_INVOICE_PACKING_DOC, item.ID);
        toast.success("Document deleted successfully");
      }
      if (item.DataOf === "5M") {
        await deleteInvPackingDoc5M(item.ID);
        dispatcher(actionTypes.DELETE_INVOICE_PACKING_DOC, item.ID);
        toast.success("Document deleted successfully");
      }
    } catch (error) {
      setIsDelete({
        status: false,
        ID: "",
      });
      toast.error("Unable to delete document");
    }
  }

  return (
    <>
      {loader && (
        <>
          <div
            style={{
              display: "flex",
              marginLeft: "40%",
              marginTop: "-5%",
              zIndex: "99",
            }}
          >
            <p style={{ fontSize: "25px" }}>Loading...</p>
            <LoaderSpinner />
          </div>
        </>
      )}
      <Modal
        show={show}
        centered
        onHide={() => hide()}
        dialogClassName="InvoicePackingViewerModalWidth"
        contentClassName="InvoicePackingViewerModalHeight"
      >
        <Modal.Body>
          <div>
            <div
              style={{
                width: "88vw",
                marginTop: "-30px",
                display: "flex",
                justifyContent: "space-between",
                position: "fixed",
                backgroundColor: "white",
                zIndex: "99",
                borderRadius:"10px",
                marginLeft:"-8px"
              }}
            >
              <h3 style={{ marginTop: "30px", fontWeight: "500" }}>
                View Doc.
              </h3>
              <Button
                size="sm"
                style={{
                  height:"40px",
                  marginTop: "30px",
                }}
                onClick={() => hide()}
              >
                Close
              </Button>
            </div>
            <div className="invPackingDocContainer">
              <div className="invPackingDocList">
                {docInvoiceLink.length > 0 &&
                  docInvoiceLink.map((item) => {
                    function preventXLSXDoc() {
                      if (
                        includes(item.docLink.split("?")[0].split("."), "xlsx") || includes(item.docLink.split("?")[0].split("."), "xlsm")
                      ) {
                        return false;
                      } else return true;
                    }
                    return (
                      <>
                        {item.InvoicePackingDoc && (
                          <div className="InvoiceViewPDF">
                            {
                              <div
                                className="xlsxDocView"
                                onClick={() => setShowIframe(item)}
                              >
                                <i
                                  className="bx bxs-file-doc xlsxDocIconButton"
                                  style={{
                                    transform: "scale(2.5)",
                                    color: preventXLSXDoc() ? "red" : "green",
                                    marginLeft: "35px",
                                    zIndex: "0",
                                  }}
                                ></i>
                                <p className="xlsxDocView__ptag">
                                  {item.InvoicePackingDoc.split(".xlsx_") || item.InvoicePackingDoc.split(".xlsm_")}
                                </p>
                                {type === "departureScreen" && <Button
                                  className="btn-primary btn-pill btn-sm mr4 sb xlsxDocDeleteButton"
                                  onClick={() => deleteDoc(item)}
                                >
                                  <i
                                    class="bx bxs-trash-alt"
                                    style={{
                                      transform: "scale(2)",
                                      color: "white",
                                      marginLeft: "20px",
                                    }}
                                  ></i>
                                </Button>}
                              </div>
                            }
                          </div>
                        )}
                      </>
                    );
                  })}
                  {!loader && dataPresent.length === 0  && (
                    <Typewriter
                      words={["Upload the PDF To View..."]}
                      cursorClassName="cursor"
                      className="InvoicePackingPDFTypewritter"
                    />
                  )}
              </div>
              <div className="invPackingDocIframe">
                {!loader && showIframe && isDelete.ID !== showIframe.ID && (
                  <iframe title="invPackingDoc" src={showIframe.docLink} />
                )}
                {!loader && !showIframe && (docInvoiceLink.length > 0 && docInvoiceLink[0].InvoicePackingDoc) && (
                  <Typewriter
                    words={["Select the PDF To View..."]}
                    cursorClassName="cursor"
                    className="InvoicePackingPDFIframeTypewritter"
                  />
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default InvoicePackagingPDFViewer;
